import { Layout } from 'antd';
import React from 'react';
import './services.css';


const { Content } = Layout;

function Services() {
  return (
    <Content>
      <div className="page">
        <h1>Our Apps</h1>
        <p>At Gila Dynamics, we develop our own simple apps for iOS and Android that aim to enhance daily life. From productivity tools to fun games, our apps are designed with users in mind.</p>
        <ul>
          <li>Productivity Apps: Tools to help manage your day</li>
          <li>Games: Fun and engaging mobile games</li>
          <li>Utilities: Apps that make life easier</li>
        </ul>
      </div>
    </Content>
  );
}

export default Services;
